import api from './api';
import { Devotional } from '../types';

export const devotionalService = {
  getAll: async (): Promise<Devotional[]> => {
    const response = await api.get('/devotionals');
    return response.data;
  },

  getById: async (id: string): Promise<Devotional> => {
    const response = await api.get(`/devotionals/${id}`);
    return response.data;
  },

  getToday: async (): Promise<Devotional> => {
    const response = await api.get('/devotionals/today');
    return response.data;
  },

  create: async (data: Partial<Devotional>): Promise<Devotional> => {
    const response = await api.post('/devotionals', data);
    return response.data;
  },

  update: async (id: string, data: Partial<Devotional>): Promise<Devotional> => {
    const response = await api.patch(`/devotionals/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/devotionals/${id}`);
  },
};
